import { Link, useLocation } from "react-router-dom";

export const SidebarLinks = (props: {
  routes: RoutesType[];
  onLinkClick?: () => void;
}): JSX.Element => {
  let location = useLocation();
  const { routes, onLinkClick } = props;

  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route, index) => {
      if (
        (route.layout === "/admin" || route.layout === "/auth") &&
        route.icon
      ) {
        return (
          <Link
            key={index}
            to={route.layout + "/" + route.path}
            onClick={() => {
              // Close sidebar only on mobile
              if (window.innerWidth < 1200 && onLinkClick) {
                onLinkClick();
              }
            }}
          >
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8"
                key={index}
              >
                <span
                  className={`${
                    activeRoute(route.path)
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <></>}
                </span>
                <p
                  className={`leading-1 mr-2 flex ${
                    activeRoute(route.path)
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };

  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
